import React, {useState, useEffect} from 'react';
import lodash from 'lodash';
import {isMobile} from 'react-device-detect';
import BlockHeadlineComponent from '../Headline/BlockHeadlineComponent';
import SubscriberItemComponent from './SubscriberItemComponent';
import ErrorComponent from '../Errors/ErrorComponent';
import errors from '../Errors/errors';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import SelectNewFamilyNumberComponent from './SelectNewFamilyNumberComponent';
import Helper from '../../../../utilities/helper';
import {stepEnum, packageSelectionStatus} from '../ChangePricePlanConsts';
import SelectAccountSticky from '../../../Shared/SelectAccountSticky/SelectAccountSticky';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {gAChangePPSubscribersCount} from '../reports/gaReports';
import { regexPatterns } from '../../../../utilities/validation/validationVariables';
import {gtag4} from '../../../../utilities/analytics/tracking';
import {
  dwhSelectAccountDisplay,
  dwhSelectAccountCurrentPackageClick,
  dwhSelectAccountClick,
  dwhErrorBusinessAccount,
  dwhErrorFuturePP,
} from '../reports/dwhReports';
import { dwhDictionary,dwhReport } from '../../IdfSaleBlock/dwhReports/dwhGeneralReport';
import BlockingDualNumberPage from '../../../Shared/BlockingDualNumberPage/BlockingDualNumberPage';
import { ProcssType } from '../../../Shared/BlockingDualNumberPage/constant';

const SelectAccountComponent = ({props, startOver, backToPrivateArea, showCurrentPackage, activeAccount, setActiveAccount, shouldDisplayThirdParty, mainTitle, secondaryTitle, magicLinkNum}) => {
  if (
    props.data.selectCellularPackageProcess?.status == packageSelectionStatus.SELECTING &&
    props.data.selectCellularPackageProcess?.activeNumber
  ) {
    return null;
  }


  let currentOfferId = props.data.selectedAccount?.pricePlan;
  const pageURL = window.location.href;
  const customerName = `${props.userData.loginData?.userDetails?.firstName} ${props.userData.loginData?.userDetails?.lastName}`;
  const id = props.userData.loginData?.userDetails?.IDNumber;
  const subscriber = props.userData.loginData?.userDetails?.contactNumber;
  const selectBoxObj = magicLinkNum ? [magicLinkNum] : lodash.map(props.data.allCellularPackagesForAccountData, 'subscriberNo');
  const [isNewFamilyMemberChecked,setIsNewFamilyMemberChecked]=useState(false);
  const [newFamilyMemberselectedPhoneNumber, setNewFamilyMemberSelectedPhoneNumber] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  useEffect(() => {
    if (props.data.currentStep == stepEnum.SELECT_ACCOUNT && (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated)) {
      if (!props.data.selectedMarketPackage) {
        gtag4({
          event: 'CellPackUpdateP2_Step6_PhoneNumberPage',
          step: '6',
          action: 'PhoneNumberPage',
          title: 'שינוי חבילת סלולר',
          button: 'אישור',
        });
      }
      dwhSelectAccountDisplay({subscriber, pageURL, customerName, id});
    }
  }, []);

  useEffect(() => {
    if (props.data.currentStep == stepEnum.SELECT_ACCOUNT && props.data.allCellularPackagesForAccountData?.length > 1) {
      setTimeout(() => {
        props.saveToHistory();
      }, 2000);
    }
  }, [props.data.allCellularPackagesForAccountData]);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.data.allCellularPackagesForAccountData && props.data.allCellularPackagesForAccountData.length == 0) {
      goToErrorPage(errors.server_error, 'server_error', true);
    } else {
      if (props.data.allCellularPackagesForAccountData && !props.data.selectedAccount) {
        let numberToCheck;
        if (
          ((props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) && props.data.allCellularPackagesForAccountData.length == 1) ||
          props.userData.loginData.isOtpAuthenticated
        ) {
          if (props.userData.loginData.isOtpAuthenticated)
            numberToCheck = props.userData.loginData?.userDetails?.contactNumber;
          else
            numberToCheck = props.data.allCellularPackagesForAccountData[0].subscriberNo;

            if(!shouldDisplayThirdParty){
              checkAccountAndContinue(numberToCheck);
            }
        }
        else if((props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) && magicLinkNum)
          checkAccountAndContinue(magicLinkNum);

        else
          gAChangePPSubscribersCount(props.data.allCellularPackagesForAccountData.length);

      }
    }
  }, [props.data.allCellularPackagesForAccountData]);

  useEffect(() => {
      if(isNewFamilyMemberChecked && !activeAccount){
        setActiveAccount(null);
      }
      else if(activeAccount){
        setIsNewFamilyMemberChecked(false);
      }
      isSubmitDisabledHandle();
  }, [activeAccount]);


  useEffect(() => {
    if(isNewFamilyMemberChecked ){
      setActiveAccount(null);
    }
    isSubmitDisabledHandle();
}, [isNewFamilyMemberChecked]);

  const isSelectedNewFamily = () => {
    setIsNewFamilyMemberChecked(!isNewFamilyMemberChecked);
  }

  const handleSelectedPhoneNumberChange = (phoneNumber) => {
    setNewFamilyMemberSelectedPhoneNumber(phoneNumber);
  };

  const isSubmitDisabledHandle = () => {
    let regex = new RegExp(regexPatterns.phoneRegex);

    if (activeAccount || (isNewFamilyMemberChecked && regex.test(newFamilyMemberselectedPhoneNumber))) {
      return setIsSubmit(true);
    }
    return setIsSubmit(false);
  };


  const redirectToLoginPage = async () => {
    await props.resetState();
    let returnUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase().split('#')[0]);
    props.redirectToLogin({
      returnUrl: returnUrl,
      cancelUrl: Helper.getRedirectToLoginReturnAndCancelUrl()?.cancelUrl,
      template: 'CellPackUpdate',
    });
  };

  const goToErrorPage = (text, reason, doCallback) => {
    props.setError({text: text, reason: reason});
    if (doCallback) {
      props.handleCurrentStep({step: stepEnum.CALL_BACK, error: true});
    }
  };
  function ifFamilyPackages() {
    if (
      props.organizationData?.organizationCodeList?.value?.length > 0 &&
      props.organizationData?.specialPackagesCellularList?.expandedValue?.length > 0
    ) {
      return true;
    } else return false;
  }

  const isAccountMidTypeNotValid = (accountMidType,allowedMidType) => {
    return accountMidType != allowedMidType || (accountMidType == allowedMidType && !ifFamilyPackages())
  }
  const checkAccountAndContinue = async(subscriberNo) => {

    var subData = props.data.allCellularPackagesForAccountData.filter((item) => item.subscriberNo == subscriberNo)?.[0];

    if(subData?.dual_number_device =='2' ){
      props.handleCurrentStep({ step: stepEnum.BLOCKING_DUAL_NUMBER, data: {subscriberNo: subscriberNo}, error: false });
      return;
    }

    dwhReport(dwhDictionary.IDFFamilyMember_SelectionBan_Ongoing);
    //GA old
    gaEvent(
      gaParams.CHANGE_PRICE_PLAN_CLICK_SELECT_SUBSCRIBER_FOR_CHANGE.category,
      gaParams.CHANGE_PRICE_PLAN_CLICK_SELECT_SUBSCRIBER_FOR_CHANGE.eventType,
      gaParams.CHANGE_PRICE_PLAN_CLICK_SELECT_SUBSCRIBER_FOR_CHANGE.eventParams,
    );
    //GA 4
    if (
      props.data.currentStep == stepEnum.SELECT_ACCOUNT &&
      (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) &&
      !props.data.selectedMarketPackage
    ) {
      gtag4({
        event: 'CellPackUpdateP2_Step7_PhoneNumberContinueButton',
        step: '7',
        action: 'PhoneNumberContinueButton',
        title: 'שינוי חבילת סלולר',
        button: 'אישור',
      });
    }

    if(isNewFamilyMemberChecked) {
      await props.validateAndSendMagicLink({subscriber: newFamilyMemberselectedPhoneNumber,
                                            link: props.iContent.linkToThirdParty?.value});
      return;
    }

    if (props.data.allCellularPackagesForAccountData?.length > 0) {
      const phoneNumber = subscriberNo;
      const account = props.data.allCellularPackagesForAccountData.filter((item) => item.subscriberNo == subscriberNo)[0];
      currentOfferId = account.pricePlan;
      if (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) {
        dwhSelectAccountClick({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
      }

      if (account.modemInd) {
        goToErrorPage(errors.modem, 'modem', false);
      } else if (account.productInBundle) {
        goToErrorPage(errors.bundle, 'bundle', true);
      } else if (account.subStatus == 'S') {
        goToErrorPage(errors.sub_status, 'sub_status', true);
      } else if (account.npStatus != null && account.npStatus.trim() != 'API') {
        goToErrorPage(errors.np_status, 'np_status', false);
      } else if (((account.accountType == 'C' || account.accountType == 'M') &&
        (isAccountMidTypeNotValid(account.accountMidType,'+')))
      ) {
        //DWH
        dwhErrorBusinessAccount({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
        goToErrorPage(errors.account_type, 'account_type', false);
      } else if (account.futurePPInd != false) {
        //DWH
        dwhErrorFuturePP({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
        goToErrorPage(errors.futurePPInd, 'futurePPInd', false);
      } else {
        props.getSelectedSubscriberDetails(account);
      }
    }
  };

  function gaOnClickShowCurrentPackage(accountNum) {
    //GA 4
    if (
      props.data.currentStep == stepEnum.SELECT_ACCOUNT &&
      (props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) &&
      !props.data.selectedMarketPackage
    ) {
      gtag4({
        event: 'CellPackUpdateP2_Step8_PackageInfoButton',
        step: '8',
        action: 'PackageInfoButton',
        button: 'לצפיה בחבילה הקיימת',
        title: 'שינוי חבילת סלולר',
      });
      //DWH
      let phoneNumber = accountNum;
      dwhSelectAccountCurrentPackageClick({currentOfferId, subscriber, pageURL, customerName, id, phoneNumber});
    }
    showCurrentPackage(accountNum, false);
  }

  function allAccountsListHtml() {
    if(props.data?.allCellularPackagesForAccountData)
      if (((props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) && props.data.allCellularPackagesForAccountData?.length > 1) || shouldDisplayThirdParty) {
        return (
          <div className={`select-account-step max-width-440 m-auto`}>
            <div className={`${isMobile ? 'w-100 m-0' : ''}`}>
              <div className='mr-auto ml-auto mb-2'>
                <BlockHeadlineComponent currentStep={props.data.currentStep} mainText={mainTitle} description={secondaryTitle} />
              </div>
            </div>
            <div className={`${isMobile ? 'w-100 m-0' : ''}`}>
              <div xs={12} className='m-auto'>
                <div className={`subscribers-flow`}>
                  {props.data.allCellularPackagesForAccountData.map((account, index) => {
                    return (
                      <SubscriberItemComponent
                        index={index}
                        key={index}
                        account={account}
                        showCurrentPackage={gaOnClickShowCurrentPackage}
                        activeAccount={activeAccount}
                        setActiveAccount={setActiveAccount}
                      />
                    );
                  })}
                </div>
                {shouldDisplayThirdParty && (
                  <div className={`subscribers-flow`}>
                    <SelectNewFamilyNumberComponent
                      isSelected={isNewFamilyMemberChecked}
                      setIsSelected={isSelectedNewFamily}
                      setActiveAccount={setActiveAccount}
                      activeAccount={activeAccount}
                      onPhoneNumberChange={handleSelectedPhoneNumberChange}
                      setIsSubmit={setIsSubmit}
                  />
                  </div>
                )}
                <div className={`d-flex ${isSubmit ? '' : 'disabled'}`}>
                  <BtnSubmit
                    text={'אישור'}
                    onclick={() => {
                      checkAccountAndContinue(activeAccount ? activeAccount.subscriberNo : newFamilyMemberselectedPhoneNumber);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }
  }

  const errorButtonAction = () => {
    if ((props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated) && props.data.allCellularPackagesForAccountData?.length == 1) {
      backToPrivateArea();
    } else {
      startOver();
    }
  };

  return (
    <>
      {!props.data.error ? (
        <>
              {props.data.currentStep == stepEnum.SELECT_ACCOUNT ? (
                allAccountsListHtml()
              ) : (
                <>
                  {props.data.selectCellularPackageProcess?.status == packageSelectionStatus.SELECTING && (
                    <SelectAccountSticky
                      selectBoxObj={selectBoxObj}
                      selectedItem={selectBoxObj.filter(option => option === props.data.selectedAccount?.subscriberNo)?.[0]}
                      onSelectChange={checkAccountAndContinue}
                      showExtraLink={true}
                      linkAction={showCurrentPackage}
                      extraLinkTitle={'לצפיה בחבילה הקיימת'}
                      redirectToLogin={redirectToLoginPage}
                    />
                  )}
                </>
              )}
       </>

      ) : (
        <div className={`${isMobile ? 'w-100 m-0' : ''}`}>
          <ErrorComponent
            props={props.data}
            buttonFunction={errorButtonAction}
            redirectToLogin={redirectToLoginPage}
            saveToHistory={props.saveToHistory}
            likeHistoryStep={props.data.allCellularPackagesForAccountData?.length > 1}
          />
        </div>
      )}
    </>
  );
};

export default SelectAccountComponent;
